import React from "react";
import { Twitter, Music2, MessageCircle, Instagram } from "lucide-react";

export default function Footer({ settings }) {
  return (
    <footer data-testid="footer" className="bg-[#0d0605] border-t border-[#F0E8DB]/15 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 text-center">
        <img src="/logo.jpg" alt="شعار نادي المسرح" data-testid="footer-logo-image" className="h-16 w-auto rounded-lg object-contain border border-[#F0E8DB]/50 mx-auto mb-3" />
        <div className="text-[#F0E8DB] font-semibold">نادي المسرح</div>
        <div className="text-[#F0E8DB] text-xs font-serif-en tracking-widest mt-1">THEATER CLUB · {new Date().getFullYear()}</div>
        {settings?.email && <div className="text-[#BFB3A0] text-sm mt-4">{settings.email}</div>}
        <div className="flex items-center justify-center gap-4 mt-4">
          {settings?.twitter && <a data-testid="footer-twitter-link" href={settings.twitter} target="_blank" rel="noreferrer" aria-label="X" className="text-[#C5B8A8] hover:text-[#F0E8DB]"><Twitter size={18} /></a>}
          {settings?.tiktok && <a data-testid="footer-tiktok-link" href={settings.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" className="text-[#C5B8A8] hover:text-[#F0E8DB]"><Music2 size={18} /></a>}
          {settings?.whatsapp && <a data-testid="footer-whatsapp-link" href={settings.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="text-[#C5B8A8] hover:text-[#F0E8DB]"><MessageCircle size={18} /></a>}
          {settings?.instagram && <a data-testid="footer-instagram-link" href={settings.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-[#C5B8A8] hover:text-[#F0E8DB]"><Instagram size={18} /></a>}
        </div>
        <div className="text-[#5c4e3c] text-xs mt-4">صُنع بشغف على خشبة الجامعة.</div>
      </div>
    </footer>
  );
}
